/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `Velikost hlavy (cm²)`
};

const da_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `størrelsen på sien (cm²)`
};

const de_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `Siebgröße (cm²)`
};

const en_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `Head Size (cm²)`
};

const es_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `tamaño del tamiz (cm²)`
};

const fr_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `Taille du tamis (cm²)`
};

const hu_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `Szita Mérete (cm²)`
};

const it_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `setaccio (cm²)`
};

const nl_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `zeef (cm²)`
};

const pl_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `sitka (cm²)`
};

const pt_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `peneira (cm²)`
};

const sv_attributes_head_size = /** @type {(inputs: {}) => string} */ () => {
	return `siktet (cm²)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_head_size = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_head_size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_head_size", locale)
	if (locale === "cs") return cs_attributes_head_size(inputs)
	if (locale === "da") return da_attributes_head_size(inputs)
	if (locale === "de") return de_attributes_head_size(inputs)
	if (locale === "en") return en_attributes_head_size(inputs)
	if (locale === "es") return es_attributes_head_size(inputs)
	if (locale === "fr") return fr_attributes_head_size(inputs)
	if (locale === "hu") return hu_attributes_head_size(inputs)
	if (locale === "it") return it_attributes_head_size(inputs)
	if (locale === "nl") return nl_attributes_head_size(inputs)
	if (locale === "pl") return pl_attributes_head_size(inputs)
	if (locale === "pt") return pt_attributes_head_size(inputs)
	return sv_attributes_head_size(inputs)
};
export { attributes_head_size as "attributes.head_size" }